import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;
    
    // Skip if no measurement ID or placeholder value
    if (!measurementId || measurementId?.includes('your-google-analytics-id')) {
      return;
    }

    // Initialize GA4 if not already loaded
    if (!window.dataLayer) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = [];
      function gtag(...args) {
        window.dataLayer?.push(...args);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', measurementId, {
        send_page_view: false // We'll manually track page views
      });
    }
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
        page_title: document.title
      });
    }
  }, [location]);
}

// Helper function to track custom events
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
}

// Helper function to track conversions
export function trackConversion(conversionName, value = null) {
  if (typeof window.gtag !== 'undefined') {
    const params = { conversion_name: conversionName };
    if (value !== null) {
      params.value = value;
      params.currency = 'USD';
    }
    window.gtag('event', 'conversion', params);
  }
}

// Helper function to track scroll depth
export function trackScrollDepth(depth) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'scroll_depth', {
      depth_percentage: depth,
      page_path: window.location?.pathname
    });
  }
}
